/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconNotificationsFilled from 'DesignSystem/Svgs/TysiaIconNotificationsFilled/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/MessageIndicatorIcon/No"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconNotificationsFilled
  viewPath={`${viewPath}/TysiaIconNotificationsFilled`}
 width={16}
 height={16}
 fill={dtColorsWhite}
/>
{children}
</React.Fragment>)
}